import { useState, useEffect } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { HorizontalLine } from "../horizontal-line/horizontal-line";

import room202 from "../../assets/room202.jpg";
import room206 from "../../assets/room206.jpg";
import room202_angle from "../../assets/room202_angle.jpg";
import room206_angle from "../../assets/room206_angle.jpg";

import "./slider.css";
import { BookingBar } from "../booking-bar/booking-bar";

export const ImageSlider = () => {
  const location_url = "https://maps.app.goo.gl/7dMkhzgd52KHvuNz7";
  const sliderImages = [
    {
      url: room202,
      heading: "Spacious Rooms",
      description:
        "Our hotel currently runs 21 comfortable, cozy and spacious rooms which are categorized into Standard Room, Deluxe Room and Suite Room",
      button: "View Rooms",
      link: "#rooms",
    },
    {
      url: room206,
      heading: "Courteous Service",
      description:
        "We at Hotel The Country Yard are dedicated to make your experience in Pokhara a pleasant one with various facilities.",
      button: "Check Services",
      link: "#services",
    },
    {
      url: room202_angle,
      heading: "Perfect Location",
      description:
        "Our hotel is located only 6-7 minutes walking distance away from Phewa Lake. Yet it lies in the peaceful Street of Lakeside, away from city noises.",
      button: "Get Location",
      link: location_url,
    },
    {
      url: room206_angle,
      heading: "Dedicated Staffs",
      description:
        "We at Hotel The Country Yard believe in the quality of service and our staffs are dedicated to match all your expectations from a hotel.",
      button: "About Us",
      link: "#services",
    },
  ];

  let intervalTime = 5000;
  let slideInterval;
  const autoScroll = false;

  function auto() {
    slideInterval = setInterval(nextSlide, intervalTime);
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, []);

  useEffect(() => {
    if (autoScroll) {
      auto();
    }
    return () => clearInterval(slideInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  const prevSlide = () => {
    console.log("here");
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? sliderImages.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === sliderImages.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <div className=" h-[calc(50vh)] md:h-[calc(100vh_-_80px)] w-100vh m-auto relative group">
      <div
        className="absolute top-0 w-full h-full bg-center bg-cover transition-all ease-out duration-500"
        style={{
          backgroundImage: `url(${sliderImages[currentIndex].url})`,
        }}
      >
        <div className="w-full h-full text-white backdrop-brightness-50">
          <div className="w-[300px] md:w-[600px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  ">
            <span className=" text-[30px] md:text-[50px] font-[300] text-center flex justify-center">
              {sliderImages[currentIndex].heading}
            </span>
            <div className="hidden md:block">
              <HorizontalLine width={100} />
            </div>
            <p className="hidden md:flex text-center mb-[30px]">
              {sliderImages[currentIndex].description}
            </p>
            <span className="flex justify-center mt-[40px] md:mt-[0px]">
              <button
                id={"slider-btn" + currentIndex}
                className="bg-[#b99470] w-[130px] h-[40px] text-white "
                onClick={() => {
                  window.open(sliderImages[currentIndex].link, "_self");
                }}
              >
                <p className="">{sliderImages[currentIndex].button}</p>
              </button>
            </span>
          </div>
        </div>
      </div>
      {/* Left Arrow */}
      <div className="md:block group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl  text-white cursor-pointer z-[1]">
        <BsChevronLeft
          onClick={prevSlide}
          className="stroke-2 text-[20px] md:text-[30px]"
        />
      </div>
      {/* Right Arrow */}
      <div className="md:block group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl  text-white cursor-pointer z-[1]">
        <BsChevronRight
          onClick={nextSlide}
          className="stroke-2 text-[20px] md:text-[30px]"
        />
      </div>
      <div className="hidden md:block">
        <BookingBar />
      </div>
    </div>
  );
};
